<template>
  <div class="page">
    <div class="row--central mv4 mh2">
      <img
        class="image--circle image--size-x-3"
        :src="linePictureUrl"
        @error="$event.target.src = clinic.urls.substitute"
      >
      <div class="column--central">
        <font-awesome-icon
          :icon="['fas', 'angle-double-right']"
          class="mh8"
        />
      </div>
      <img
        class="image--circle image--size-x-3"
        :src="clinic.urls.logo"
      >
    </div>
    <div class="page__text">
      <div>{{ clinic.金安心.fullname }} 隱私權保護及資訊安全政策</div>
      <div class="align--left">
        <br>感謝您使用「{{ clinic.金安心.fullname }} LINE 官方帳號功能服務」(以下稱本系統），
        本系統是由{{ clinic.金安心.fullname }}進行管理(以下稱本院)。
        為使您能夠安全的使用本院提供之各項服務與資訊，依據「個人資料保護法」之相關規定與立法精神，
        特此向您說明本系統的「隱私權保護及資訊安全」政策，以保障您的權益。
        當您使用本系統時，務須先行確認是否同意本系統所公布之現行隱私權聲明。如果您不同意本聲明內容，請勿提供本系統提供相關個人資料。
        <br>
        <br>一、隱私權聲明與個人資料保護條款
        <br>請您於使用前詳加閱讀本院將如何使用及保護您的隱私，
        當您使用或資訊連結本系統，即代表您同意此隱私權聲明及個人資料保護條款(以下稱本條款)，
        並同意下揭各項權利及義務。
        <br>
        <br>二、服務之目的及資料使用與範圍 <br>1.
        除法令要求或合於法令規範外，我們不會向任何第三方揭露任何直接關於您個人識別之資訊。
        <br>2.
        您所提供之個人資料，僅作為協助您進行預約掛號、預約紀錄查詢以及本系統相關功能服務。
        <br>
        <br>三、資料安全 <br>1.
        本系統採用SSL加密技術，並盡力以合理之技術及程序，保障所有個人資料之安全。
        <br>
        <br>四、資料之蒐集、處理及利用 <br>1.
        在本聲明中，「個人資料」指可辨認個人身份的資料，例如：身分證字號、出生年月日、手機號碼，它的含括範圍「個人資料保護法」之規範。
        <br>2.
        若您自願提供個人資料給予本系統時，即表示您同意我們可依據您選擇留存個人資料之該項服務範圍目的來蒐集、處理及利用您的個人資料。
        此紀錄僅於內部應用做為我們增進本系統服務之參考依據，絶不對外公布。
        <br>
        <br>五、行為規則
        <br>您同意在使用本服務時，必須遵守本條款或本院的規範或政策，如違反下列行為，
        本院擁有停用您使用本系統服務之權利，以及保留求償權利，以下為行為規則：
        <br>1.
        主張本系統之服務為本院提供之醫療行為服務，或要求為此負賠償責任。
        <br>2. 構成違法之行為。 <br>3. 侵害他人智慧財產權。 <br>4.
        侮辱、誹謗、騷擾、脅迫、傷害、詐欺、侵害他人隱私之行為及其他侵權之行為。
        <br>5. 非經過當事人同意並假冒身分。 <br>6.
        造成本院之設備不合理之負擔。 <br>7. 干擾或企圖干擾本服務之正常運作。
        <br>8.
        破解或以各種方式繞過任何本院用以防止或限制使用服務（或一部分服務）的措施。
        <br>9.
        以破譯、反編譯、逆向工程或其他方式，試圖獲得任何原始或相關資料。
        <br>10. 以任何方式創造任何部分服務的衍生著作品。 <br>11.
        以任何方式轉讓本協議之任何權利。
        <br>
        <br>六、免責聲明 <br>1.
        您使用本服務所提交的資料，請確認您是資料的擁有者或您有權提供該資料。
        並請務必確認您所提供資料之真實性。
        若個人資料有任何異動，請主動於本院進行聯繫，若您提供錯誤、不實、逾時或不具完整性或有誤導性之資料，損及您的權益或造成損害，本院將不擔負任何責任。
        <br>2.
        您同意本條款，表示您已閱讀、了解並同意接受本條款之全部內容及其後修訂變更之規定。
        若您未滿二十歲，當您使用或登入本系統，即視為您已取得法定代理人之同意並同意遵守所有規範。
        <br>
        <br>七、權利保留 <br>1.
        若您對本聲明有任何疑問，或對所留存之個人資料有任何權利主張，歡迎隨時與我們聯絡
        <br>2.
        本院有權隨時修改或變更本服務條款之內容，修改後的服務條款內容將公佈本系統上，將不會進行個別通知，建議使用者應隨時注意該等修改或變更。
        使用者如在本服務條款修改或變更後繼續使用本APP時，視為使用者已閱讀、瞭解並同意接受該等修改或變更。
        <br>3.
        本系統隱私權政策將因應需求隨時進行修正，修正後的條款將刊登於本系統上。
      </div>
    </div>
    <div
      class="label label--primary m5"
      @click="$emit('close')"
    >
      關閉視窗
    </div>
  </div>
</template>
<script>
import spiderman from '@/spiderman';

export default {
  props: {
    linePictureUrl: {
      type: String,
      default: spiderman.clinic.substitute,
    },
  },
  emits: ['close'],

  setup() {
    return {
      clinic: spiderman.clinic,
    };
  },
};
</script>
